import React from "react";
import { NONQUAL_ACCOUNTS, PRETAX_ACCOUNTS, TAXFREE_ACCOUNTS } from "../../shared/constants";
import {currencyFormatNoDecimals, formatNumberToPercentage, INCOME_TYPES} from "../../shared/shared";
import RoadmapOwnerCell from "./roadmapOwnerCell";

export const ViolatilityInsuranceTransfers = (props) => {
    const financialDataItemTHStyle = {
        padding: "0.5em"
    };
    const financialDataItemTDStyle = {
        padding: "0.5em",
        fontSize: "0.9em",
        textAlign: "center"
    };
    const financialDataItemStyle = {
        display: "inline-block",
        width: "200px",
        marginRight: "1em"
    };
    const financialDataItemLabelStyle = {
        display: "inline-block",
        marginRight: "1em"
    };
    const subSectionStyle = { color: '#157ee8', margin: '25px 0', fontSize: "1em" }

    const violatilityInsurances = props?.insuranceTransfers.filter((e) => e.insuranceType !== "GUARANTEED_INCOME");

    if (violatilityInsurances.length === 0) {
        return <div><h2 style={subSectionStyle}>Insurance</h2></div>
    }

    const getAccountsAccountText = (element) => {
        if (element.fundingSourceType !== 'ACCOUNT') {
            return INCOME_TYPES[element.fundingSourceType];
        } else {
            let typeMap = {};
            const options = props.accounts.filter(item => {
                return item.appliesTo === element.appliesTo && item.id != null;
            }).map((item) => {
                if (typeMap[element.appliesTo + item.taxType + item.value]) {
                    typeMap[element.appliesTo + item.taxType + item.value].push(typeMap[element.appliesTo + item.taxType + item.value].length + 1);
                } else {
                    typeMap[element.appliesTo + item.taxType + item.value] = [1];
                }
                return item;
            }).map((item) => {
                const option =
                    item.taxType === "NON_QUALIFIED"
                        ? NONQUAL_ACCOUNTS.find((e) => e.value === item.accountType)
                        : item.taxType === "PRE_TAX"
                            ? PRETAX_ACCOUNTS.find((e) => e.value === item.accountType)
                            : TAXFREE_ACCOUNTS.find((e) => e.value === item.accountType);

                let text = "";
                if (option != undefined) {
                    text = option.text + " - " + currencyFormatNoDecimals(item.value)
                }
                if (typeMap[element.appliesTo + item.taxType + item.value].length == 1 && typeMap[element.appliesTo + item.taxType + item.value][0] == 1) {
                    typeMap[element.appliesTo + item.taxType + item.value].shift();
                } else if (typeMap[element.appliesTo + item.taxType + item.value].length > 0) {
                    text = text + " - " + typeMap[element.appliesTo + item.taxType + item.value][0];
                    typeMap[element.appliesTo + item.taxType + item.value].shift();
                }
                return {id: item.id, value: text};
            }).filter((item) => item.id === element.accountId);
            return options.length > 0 ? options[0].value : "";
        }
    }

    return <div>
        <h2 style={subSectionStyle}>Insurance</h2>
        <table style={{
            width: "100%",
            borderCollapse: "collapse"
        }}>
            <thead>
            <tr style={{
                backgroundColor: "#157ee8",
                color: "white",
            }}>
                <th style={financialDataItemTHStyle}>Owner</th>
                <th style={financialDataItemTHStyle}>Insurance Type</th>
                <th style={financialDataItemTHStyle}>Funding Source</th>
                <th style={financialDataItemTHStyle}>Transfer Amount</th>
                <th style={financialDataItemTHStyle}>Transfer Start Year</th>
                <th style={financialDataItemTHStyle}>Transfer End Year</th>
            </tr>
            </thead>
            <tbody>
            {violatilityInsurances.map((item, index) => {
                return <React.Fragment>
                    <tr key={index}>
                        <td style={financialDataItemTDStyle}><RoadmapOwnerCell item={item} /></td>
                        <td style={financialDataItemTDStyle}>{item.insuranceType.replace("_", " ")}</td>
                        <td style={financialDataItemTDStyle}>{getAccountsAccountText(item)}</td>
                        <td style={financialDataItemTDStyle}>{currencyFormatNoDecimals(item.transferAmount)}</td>
                        <td style={financialDataItemTDStyle}>{item.transferStartYear}</td>
                        <td style={financialDataItemTDStyle}>{item.transferEndYear}</td>
                    </tr>
                    <tr style={{
                        borderBottom: "1px solid #eee"
                    }}>
                        <td colSpan={5}  style={{
                            padding: "0.5em",
                            fontSize: "0.7em"
                        }}>
                            <div style={financialDataItemStyle}>
                                <label style={financialDataItemLabelStyle}>Cash Value Return</label>
                                <span>{formatNumberToPercentage(item.cashValueReturn, 2)}</span>
                            </div>
                            <div style={financialDataItemStyle}>
                                <label style={financialDataItemLabelStyle}>Death Benefit</label>
                                <span>{currencyFormatNoDecimals(item.deathBenefit)}</span>
                            </div>
                            <div style={financialDataItemStyle}>
                                <label style={financialDataItemLabelStyle}>Death Benefit Return</label>
                                <span>{formatNumberToPercentage(item.deathBenefitReturn, 2)}</span>
                            </div>
                        </td>
                    </tr>
                </React.Fragment>
            })}
            </tbody>
        </table>
    </div>
}

export const InsuranceTransfers = (props) => {
    const financialDataItemTHStyle = {
        padding: "0.5em"
    };
    const financialDataItemTDStyle = {
        padding: "0.5em",
        fontSize: "0.9em",
        textAlign: "center"
    };
    const financialDataItemStyle = {
        display: "inline-block",
        width: "150px",
        marginRight: "1em"
    };
    const financialDataItemLabelStyle = {
        display: "inline-block",
        marginRight: "1em"
    };
    const subSectionStyle = { color: '#157ee8', margin: '25px 0', fontSize: "1em" }

    const filterGuaranteedIncome = props?.insuranceTransfers.filter((e) => e.insuranceType === "GUARANTEED_INCOME");

    if (filterGuaranteedIncome.length === 0) return <div></div>

    const getAccountsAccountText = (element) => {
        let typeMap = {};
        const options = props.accounts.filter(item => {
            return item.appliesTo === element.appliesTo && item.id != null;
        }).map((item) => {
            if (typeMap[element.appliesTo + item.taxType + item.value]) {
                typeMap[element.appliesTo + item.taxType + item.value].push(typeMap[element.appliesTo + item.taxType + item.value].length + 1);
            } else {
                typeMap[element.appliesTo + item.taxType + item.value] = [1];
            }
            return item;
        }).map((item) => {
            const option =
                item.taxType === "NON_QUALIFIED"
                    ? NONQUAL_ACCOUNTS.find((e) => e.value === item.accountType)
                    : item.taxType === "PRE_TAX"
                        ? PRETAX_ACCOUNTS.find((e) => e.value === item.accountType)
                        : TAXFREE_ACCOUNTS.find((e) => e.value === item.accountType);

            let text = "";
            if(option != undefined) {
                text = option.text + " - " + currencyFormatNoDecimals(item.value)
            }
            if (typeMap[element.appliesTo + item.taxType + item.value].length == 1 && typeMap[element.appliesTo + item.taxType + item.value][0] == 1) {
                typeMap[element.appliesTo + item.taxType + item.value].shift();
            } else if (typeMap[element.appliesTo + item.taxType + item.value].length > 0) {
                text = text + " - " + typeMap[element.appliesTo + item.taxType + item.value][0];
                typeMap[element.appliesTo + item.taxType + item.value].shift();
            }
            return { id: item.id, value: text };
        }).filter((item) => item.id === element.accountId);
        return options.length > 0 ? options[0].value : "";
    }

    return (<div>

        <table style={{
            width: "100%",
            borderCollapse: "collapse"
        }}>
            <thead>
                <tr style={{
                    backgroundColor: "#157ee8",
                    color: "white",
                }}>
                    <th style={financialDataItemTHStyle}>Owner</th>
                    <th style={financialDataItemTHStyle}>Insurance Type</th>
                    <th style={financialDataItemTHStyle}>Account to Transfer</th>

                </tr>
            </thead>
            <tbody>
                {filterGuaranteedIncome.length > 0 && (
                    filterGuaranteedIncome.map((item, idx) => {
                        return <React.Fragment key={idx}><tr>
                            <td style={financialDataItemTDStyle}>{item.appliesTo == "CLIENT" ? "Client" : "Spouse"}</td>
                            <td style={financialDataItemTDStyle}>{item.insuranceType.replace("_", " ")}</td>
                            <td style={financialDataItemTDStyle}>{getAccountsAccountText(item)}</td>

                        </tr>
                            <tr style={{
                                borderBottom: "1px solid #eee"
                            }}>
                                <td colSpan={7} style={{
                                    padding: "0.5em",
                                    fontSize: "0.7em"
                                }}>

                                    <table style={{ width: '100%', textAlign: 'left' }}>
                                        <tr>
                                            <th>Distribution</th>
                                            <th>Net Cash Value</th>
                                            <th>Net Death Benefits</th>
                                            <th>Premium Outlay</th>
                                            <th>Year</th>
                                        </tr>
                                        {
                                            item.insuranceDetails?.map((element, idx) => {
                                                return (

                                                    <tr>
                                                        <td>{element.distribution}</td>
                                                        <td>{element.netCashValue}</td>
                                                        <td>{element.netDeathBenefits}</td>
                                                        <td>{element.premiumOutlay}</td>
                                                        <td>{element.year}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </table>


                                </td>
                            </tr></React.Fragment>
                    }))}
            </tbody>
        </table>
    </div>)

}
